import React, { useCallback, type FC } from 'react';
import Form, { Field, type OnSubmitHandler } from '@atlaskit/form';
import { Box } from '@atlaskit/primitives';
import TextField from '@atlaskit/textfield';

export const Input: FC<{ onSubmit: (message: string) => Promise<void> }> = ({ onSubmit }) => {
    const handleSubmit: OnSubmitHandler<{ vaConversationInput: string }> = useCallback(
        async (value) => {
            await onSubmit(value.vaConversationInput);
        },
        [onSubmit]
    );

    return (
        <Box>
            <Form onSubmit={handleSubmit}>
                {({ formProps }) => (
                    <form {...formProps}>
                        <Field name="vaConversationInput" defaultValue="">
                            {({ fieldProps }) => <TextField {...fieldProps} />}
                        </Field>
                    </form>
                )}
            </Form>
        </Box>
    );
};
